/** Resources slider */

(function () {
	"use strict";

	// init news and events carousel
	// eslint-disable-next-line no-undef
	new Swiper(".resources-slider-container", {
		slidesPerView: "auto",
		navigation: false,
		pagination: false,
		centeredSlides: false,
		spaceBetween: 30,
		disableOnInteraction: false,
		pauseOnMouseEnter: true
	});

}());
